<template>
  <div class="page-container packages-page">
    <portal to="page-name">Pacotes</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Pacotes</h1>
      </div>
      <div class="card-body">
        <div class="columns">
          <div class="column form-group">
            <div class="input-group">
              <input type="text" id="filter-search" name="filter-search" class="form-input"
                     v-model="filter.search" maxlength="100" autocomplete="nope">
              <button class="btn btn-neutral btn-action input-group-btn btn-icon" tabindex="-1">
                <fa-icon :icon="['fal', 'search']"/>
              </button>
            </div>
          </div>
          <div class="column col-auto">
            <button class="btn btn-primary btn-icon btn-icon-left"
                    @click="create">
              <fa-icon :icon="['fal', 'plus']"/>Novo pacote
            </button>
          </div>
        </div>
        <div class="loading loading-lg mt-2" v-if="loading" />
        <template v-else>
          <template v-if="data.items.length === 0">
            <div class="empty mt-2">
              <div class="empty-icon">
                <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
              </div>
              <p class="empty-title h5">Pacotes</p>
              <p class="empty-subtitle">
                Nenhum pacote encontrado. Verifique os filtros para realizar novas buscas.
              </p>
            </div>
          </template>
          <template v-else>
            <table class="table table-striped table-hover">
          <thead>
          <tr>
            <th class="hide-sm" style="width: 40px">#</th>
            <th>Nome</th>
            <th class="text-left">Tipo</th>
            <th class="hide-sm hide-md text-right">Ativo</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in data.items" :key="i">
            <td class="hide-sm">{{ i + 1 }}</td>
            <td><router-link :to="editLink(item)">{{ item.name }}
            </router-link></td>
            <td class="text-left">{{ placeType.getName(item.type) }}</td>
            <td class="hide-sm hide-md text-right">{{ item.active ? 'Sim' : 'Não' }}</td>
            <td class="text-right">
              <button class="btn btn-sm btn-action btn-icon btn-secondary"
                      :disabled="deleting"
                      @click="edit(item)">
                <fa-icon :icon="['fal', 'pencil']"></fa-icon>
              </button>
              <button class="btn btn-sm btn-action btn-icon btn-error ml-1"
                      :class="{loading: deleting}"
                      :disabled="deleting"
                      @click="remove(item.id)">
                <fa-icon :icon="['fal', 'times']"></fa-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import * as placeType from 'src/data/place-types';

export default {
  data() {
    return {
      debounceTimeout: null,
      loading: false,
      deleting: false,
      placeType,
      filter: {
        search: '',
      },
      data: {
        items: [],
        total: 0,
        limit: 30,
        offset: 0,
      },
    };
  },
  watch: {
    filter: {
      handler() {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(this.search, 600);
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    search() {
      this.data.offset = 0;
      this.load();
    },
    load() {
      this.loading = true;

      const params = {
        limit: this.data.limit,
        offset: this.data.offset,
      };

      if (this.filter.search.trim().length > 0) {
        params.search = this.filter.search;
      }

      this.$http.get('/packages', { params })
        .then(({ data }) => {
          this.data = data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.$router.push('/clinical/packages/create');
    },
    edit(item) {
      this.$router.push(`/clinical/packages/${item.id}/edit`);
    },
    editLink(item) {
      return `/clinical/packages/${item.id}/edit`;
    },
    remove(id) {
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente excluir este registro?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              this.deleting = true;
              close();
              return this.$http.delete(`/packages/${id}`)
                .then(() => {
                  const found = this.data.items.find(item => item.id === id);
                  if (found) {
                    const idx = this.data.items.indexOf(found);
                    this.data.items.splice(idx, 1);
                  }
                  this.$toast.show('Registro excluído com sucesso!');
                })
                .catch(() => {
                  this.$toast.error('Ocorreu um erro. Tente novamente!');
                })
                .finally(() => {
                  this.deleting = false;
                });
            },
          },
        ],
      });
    },
    paginate({ offset }) {
      this.data.offset = offset;
      this.load();
    },
  },
};
</script>

<style lang="scss">
  @import "./src/assets/scss/_variables.scss";
  .packages-page {}
</style>
